var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardKorzina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7H6.47168C4.84715 7 4.03556 7 3.45776 7.33143C2.95072 7.62227 2.56096 8.08168 2.35744 8.62964C2.12566 9.25367 2.25907 10.0542 2.52581 11.6546L2.52637 11.6576L3.69303 18.6576C3.89094 19.8451 3.99055 20.439 4.28684 20.8846C4.54801 21.2773 4.91463 21.5878 5.34497 21.7809C5.83317 21.9999 6.43483 22 7.63867 22H18.3617C19.5655 22 20.1668 21.9999 20.655 21.7809C21.0853 21.5878 21.4522 21.2773 21.7134 20.8846C22.0097 20.439 22.1087 19.8451 22.3066 18.6576L23.4733 11.6576L23.4744 11.6527C23.741 10.0535 23.8743 9.25343 23.6426 8.62964C23.4391 8.08168 23.0503 7.62227 22.5432 7.33143C21.9654 7 21.1525 7 19.528 7H18M8 7H18M8 7C8 4.23858 10.2386 2 13 2C15.7614 2 18 4.23858 18 7",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardKorzina);
export default __webpack_public_path__ + "static/media/card-korzina.953d77bc3754025bfbaf84248c1bc1f6.svg";
export { ForwardRef as ReactComponent };